<aside class="sidebar position-fixed top-0 start-0 vh-100 d-flex flex-column" data-bs-theme="dark">
  <!-- Logo Section -->
  <div class="sidebar-header d-flex align-items-center position-relative px-4">
    <img src="assets/images/dark-logo-horizontal.svg" alt="American Drone Network - Admin" width="140" />
    <!-- Close button for mobile -->
    <button class="shell-btn sidebar-close d-lg-none position-absolute top-50 end-0 translate-middle-y me-4 fs-5" (click)="closeSidebar()" aria-label="Close menu">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <!-- Navigation Sections -->
  <nav class="flex-grow-1 overflow-y-auto py-2">
    <div *ngFor="let section of getVisibleSections()">
      <ul class="list-unstyled m-0">
        <li
          *ngFor="let item of getVisibleItems(section)"
          class="sidebar-link d-flex align-items-center justify-content-between"
          [class.active]="item.active"
          [class.coming-soon]="item.comingSoon"
          (click)="navigateTo(item)"
        >
          <div class="d-flex align-items-center gap-3">
            <i [class]="'bi ' + item.icon"></i>
            <span class="text-nowrap">{{ item.label }}</span>
          </div>
          <span *ngIf="item.badge && item.badgeCount" class="badge bg-warning rounded-pill">{{ item.badgeCount }}</span>
          <span *ngIf="item.badge && !item.badgeCount" class="p-1 bg-danger rounded-circle flex-shrink-0"></span>
        </li>
      </ul>
      <div *ngIf="section.showDivider" class="sidebar-divider mx-3 my-3"></div>
    </div>
  </nav>

  <!-- Bottom Promo Section -->
  <div class="sidebar-promo p-3">
    <div class="promo-content d-flex align-items-center gap-3 p-3 rounded-2 position-relative">
      <i class="bi bi-shield-check fs-4 ms-3"></i>
      <div class="d-flex flex-column">
        <span class="promo-title fw-bold">Admin Portal</span>
        <span class="promo-subtitle">Internal Use Only</span>
      </div>
    </div>
  </div>
</aside>
